const relativeTimeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'always' })
const dateLocale = 'en-GB'

function parseDate(value) {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatRelativeDate(value, now = Date.now()) {
  const date = parseDate(value)
  if (!date) return 'Not available'

  const difference = date.getTime() - now
  const absoluteDifference = Math.abs(difference)

  if (absoluteDifference < 45000) return 'just now'

  const units = [
    { name: 'year', milliseconds: 365 * 24 * 60 * 60 * 1000 },
    { name: 'month', milliseconds: 30 * 24 * 60 * 60 * 1000 },
    { name: 'day', milliseconds: 24 * 60 * 60 * 1000 },
    { name: 'hour', milliseconds: 60 * 60 * 1000 },
    { name: 'minute', milliseconds: 60 * 1000 }
  ]
  const unit = units.find(item => absoluteDifference >= item.milliseconds) || units[units.length - 1]
  const amount = Math.round(difference / unit.milliseconds)

  return relativeTimeFormatter.format(amount, unit.name)
}

export function formatExactDate(value) {
  const date = parseDate(value)
  return date ? date.toLocaleString(dateLocale) : 'Not available'
}

export function formatTravelDates(value) {
  if (value === null || value === undefined) return ''
  return String(value).trim().replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, '$3.$2.$1')
}

export function formatTravelMonth(value) {
  if (!value) return ''
  const dateOnlyMatch = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/)
  let date = parseDate(value)
  if (dateOnlyMatch) {
    date = new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, 1)
  }
  if (!date || Number.isNaN(date.getTime())) return ''
  return date.toLocaleString('en-US', {
    month: 'long',
    year: 'numeric'
  })
}

export function formatShortDate(value) {
  const date = parseDate(value)
  if (!date) return 'Not available'
  return date.toLocaleString(dateLocale, {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export function formatScheduledDate(value, now = Date.now()) {
  const date = parseDate(value)
  if (!date) return 'Not available'

  const current = new Date(now)
  const startOfCurrentDay = new Date(current.getFullYear(), current.getMonth(), current.getDate()).getTime()
  const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
  const dayDifference = Math.round((startOfDate - startOfCurrentDay) / 86400000)
  const time = date.toLocaleTimeString(dateLocale, { hour: '2-digit', minute: '2-digit' })

  if (dayDifference === 0) return `today at ${time}`
  if (dayDifference === 1) return `tomorrow at ${time}`
  if (dayDifference === -1) return `yesterday at ${time}`
  return formatRelativeDate(value, now)
}
